export const appendBulkRow = (forms, fields, limit, generateId) => {
  if (forms.length >= limit) return forms;
  return [...forms, {
    Id: generateId(8),
    fields: fields.map((field) => ({ ...field, widgets: (field.widgets || []).map((widget) => ({ ...widget, options: { ...widget.options } })) }))
  }];
};
